export const Minus = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="3" viewBox="0 0 15 3" fill="none">
      <path
        d="M1.53564 1.96399H13.4656"
        stroke="#183344"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
